/**
 * useDispatchStore — track API dispatch in-flight để bật beforeunload warning.
 *
 * Counter để hỗ trợ multi-file song song (translate + train cùng lúc).
 * begin() trước await insertJobs, end() trong finally → browser prompt user
 * "Leave site?" nếu họ refresh/close tab giữa API window.
 */

import { create } from 'zustand';

interface DispatchState {
  inFlightCount: number;
  begin: () => void;
  end: () => void;
}

export const useDispatchStore = create<DispatchState>((set) => ({
  inFlightCount: 0,
  begin: () => set(s => ({ inFlightCount: s.inFlightCount + 1 })),
  end: () => set(s => ({ inFlightCount: Math.max(0, s.inFlightCount - 1) })),
}));
